export const COMPANY_INFO = {
  name: 'Morine Køl & Klimateknik',
  shortName: 'Morine Klimateknik',
  cvr: '30872568',
  phone: '50 90 00 67',
  phoneFormatted: '50 90 00 67',
  phoneHref: 'tel:50900067',
  email: 'Morineklimatek@gmail.com',
  emailHref: 'mailto:Morineklimatek@gmail.com',
  address: {
    street: 'Frydenborgvej 27',
    city: 'Hillerød',
    zip: '3400',
    full: 'Frydenborgvej 27, 3400 Hillerød'
  },
  openingHours: 'Mandag – Fredag: 07.00 – 16.00 (Døgnvagt ved akutte serviceaftaler)',
  tagline: 'Professionelle løsninger inden for køl, klima og energioptimering'
};

export const SERVICES_DATA = [
  {
    id: 'energioptimering',
    slug: 'energioptimering',
    title: 'Energioptimering',
    shortTitle: 'Energioptimering',
    tagline: 'Reducer energiforbruget og forbedr driftsøkonomien på eksisterende og nye anlæg',
    metaTitle: 'Energioptimering af Køleanlæg & Varmepumper | Morine Klimateknik',
    metaDescription: 'Reducer elforbruget og optimer driftsøkonomien på eksisterende og nye køle- og klimaanlæg. Teknisk analyse og intelligent styring i Nordsjælland.',
    gallerySlug: 'energioptimering',
    icon: 'fa-solid fa-bolt',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/energioptimering-system.jpg',
    description: 'Vi hjælper virksomheder med at gennemgå og optimere deres køle- og klimaanlæg. Gennem målrettet teknisk analyse, intelligent styring og udskiftning af uhensigtsmæssige komponenter reduceres både elforbrug og driftsomkostninger markant.',
    points: [
      'Gennemgang og teknisk analyse af eksisterende anlæg',
      'Optimering af driftstryk, kondensering og kompressorer',
      'Intelligent styring og frekvensregulering',
      'Markant reduktion i årlige energiomkostninger',
      'Lavere miljøpåvirkning og forbedret levetid på materiel'
    ],
    environmentalPoints: [
      'Lavere energiforbrug',
      'Optimeret driftsøkonomi',
      'Forlænget levetid på anlæg',
      'Fremtidssikret drift'
    ],
    technicalHighlights: [
      { label: 'Formål', value: 'Reduceret elforbrug & optimal virkningsgrad' },
      { label: 'Målgruppe', value: 'Erhverv, industri, detail & institutioner' },
      { label: 'Metode', value: 'Teknisk analyse, trykoptimering & intelligent styring' }
    ]
  },
  {
    id: 'varmepumper',
    slug: 'varmepumper',
    title: 'Varmepumper',
    shortTitle: 'Varmepumper',
    tagline: 'Effektiv opvarmning og køling med moderne og driftssikker varmepumpeteknologi',
    metaTitle: 'Varmepumper til Erhverv | Montering & Service i Hillerød & Sjælland',
    metaDescription: 'Driftssikre og energieffektive varmepumper til erhvervsbygninger, kontorer og produktion. Autoriserede teknikere fra Morine Køl & Klimateknik.',
    gallerySlug: 'varmepumper',
    icon: 'fa-solid fa-temperature-arrow-up',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/varmepumpe-erhverv.jpg',
    description: 'Professionelle varmepumpeløsninger tilpasset erhvervsbygninger, kontorer, produktionsfaciliteter og institutioner. Vi yder kompetent rådgivning om dimensionering, energieffektivitet og driftssikker installation.',
    points: [
      'Komplet dimensionering og projektering til erhverv',
      'Højeffektive luft-til-vand og væske-til-vand systemer',
      'Kombinerede varme- og køleløsninger til erhvervsbygninger',
      'Professionel montage og efterfølgende lovpligtig service',
      'Stabilt indeklima med lavest mulige driftsomkostninger'
    ],
    environmentalPoints: [
      'Høj energieffektivitet (SCOP / COP)',
      'Driftssikker opvarmning og køling',
      'Mindre afhængighed af fossile energikilder',
      'Langsigtet besparelse på varmeregningen'
    ],
    technicalHighlights: [
      { label: 'Teknologi', value: 'Moderne inverter- og varmepumpeteknik' },
      { label: 'Anvendelse', value: 'Kontorer, lager, produktion & erhverv' },
      { label: 'Service', value: 'Dimensionering, montering & vedligeholdelse' }
    ]
  },
  {
    id: 'groen-udvikling',
    slug: 'groen-udvikling',
    title: 'Grøn udvikling',
    shortTitle: 'Grøn udvikling',
    tagline: 'Fremtidssikrede klimaløsninger med fokus på bæredygtighed og minimal miljøbelastning',
    metaTitle: 'Grøn Udvikling & Naturlige Kølemidler | Morine Køl & Klimateknik',
    metaDescription: 'Fremtidssikret rådgivning om naturlige kølemidler, udfasning af F-gasser og overskudsvarme til erhverv. Overhold gældende miljøkrav med Morine.',
    gallerySlug: 'groen-udvikling',
    icon: 'fa-solid fa-leaf',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/groen-udvikling-klima.jpg',
    description: 'Overgangen til mere miljøvenlige løsninger stiller krav til viden om naturlige kølemidler, energigenvinding og fremtidssikrede standarder. Vi rådgiver om og installerer anlæg, der matcher nutidens og fremtidens miljø- og energikrav.',
    points: [
      'Rådgivning om udfasning af ældre kølemidler',
      'Anvendelse af miljøvenlige og naturlige kølemidler',
      'Varmegenindvinding fra køleprocesser til brugsvand og opvarmning',
      'Overholdelse af F-gas-lovgivning og gældende miljøstandarder',
      'Fremtidssikring mod stigende energiafgifter og kvoter'
    ],
    environmentalPoints: [
      'Minimal klimapåvirkning (lav GWP)',
      'Genanvendelse af overskudsvarme',
      'Fremtidssikrede teknologistandarder',
      'Mærkbare CO2-besparelser'
    ],
    technicalHighlights: [
      { label: 'Fokus', value: 'Naturlige kølemidler & overskudsvarme' },
      { label: 'Lovkrav', value: 'Fuld compliance med F-gas & miljøkrav' },
      { label: 'Effekt', value: 'Lavere CO2-aftryk & reduceret energitab' }
    ]
  },
  {
    id: 'butikskoel',
    slug: 'butikskoel',
    title: 'Butikskøl',
    shortTitle: 'Butikskøl',
    tagline: 'Driftssikre og præsentable køleløsninger til supermarkeder og detailhandel',
    metaTitle: 'Butikskøl & Frostrum til Supermarkeder & Detail | Morine Klimateknik',
    metaDescription: 'Installation og service af glasdørskølere, kølediske, frostrum og køleøer til detailhandlen. Høj fødevaresikkerhed og stabil temperaturstyring.',
    gallerySlug: 'butikskol',
    icon: 'fa-solid fa-store',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/butikskoel-supermarket.jpg',
    description: 'Vi leverer, monterer og servicerer professionelle kølemøbler, glasdørskølere, frostrum og kølediske til danske butikker og supermarkeder. Vi sikrer en stabil temperatur, der beskytter varerne og giver kunderne en indbydende oplevelse.',
    points: [
      'Kølediske, vægkølere og frostrum til detailhandlen',
      'Energieffektive glasdøre og LED-belysning for optimal præsentation',
      'Præcis og stabil temperaturstyring for fødevaresikkerhed',
      'Støjsvag og driftsikker drift i butikkens åbningstid',
      'Specialtilpassede løsninger til butikkens layout og flow'
    ],
    environmentalPoints: [
      'Stabil temperatur til beskyttelse af fødevarer',
      'Energieffektive kølemøbler med isolerende glas',
      'Driftssikker teknologi med minimal nedetid',
      'Optimeret butiksøkonomi'
    ],
    technicalHighlights: [
      { label: 'Område', value: 'Supermarkeder, bagere, slagtere & delikatesse' },
      { label: 'Udstyr', value: 'Glasdørsmøbler, frostrum & køleøer' },
      { label: 'Sikkerhed', value: 'Konstant temperatur & alarmstyring' }
    ]
  },
  {
    id: 'industrikoel',
    slug: 'industrikoel',
    title: 'Industrikøl',
    shortTitle: 'Industrikøl',
    tagline: 'Kraftfulde, skræddersyede køleanlæg med maksimal driftssikkerhed til industrien',
    metaTitle: 'Industrikøl & Proceskøling til Virksomheder | Morine Klimateknik',
    metaDescription: 'Skræddersyede industrikøleanlæg, chillere og proceskøling dimensioneret til kontinuerlig produktion med maksimal oppetid og døgnvagt.',
    gallerySlug: 'industrikol',
    icon: 'fa-solid fa-industry',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/industrikoel-anlaeg.jpg',
    description: 'Industriel produktion og proceskøling kræver ubetinget pålidelighed og robust dimensionering. Vi opbygger og servicerer industrielle køle- og fryseanlæg, proceskølere og kølerum, der sikrer kontinuerlig produktion uden dyre stop.',
    points: [
      'Skræddersyede industrianlæg dimensioneret til specifikke processer',
      'Kølevandsanlæg, chillere og proceskøling til fabrikker og lagre',
      'Højeffektive flertrins-kompressoranlæg med redundans',
      'Avanceret overvågning og automatisk driftsovervågning',
      'Hurtig teknisk support og planlagt præventivt vedligehold'
    ],
    environmentalPoints: [
      'Høj driftssikkerhed og oppetid i procesdrift',
      'Optimal energiudnyttelse ved store kølebehov',
      'Reduktion af procesrelaterede spild',
      'Langsigtet holdbarhed og modstandsdygtighed'
    ],
    technicalHighlights: [
      { label: 'Kapacitet', value: 'Højtydende proces- & industrikøling' },
      { label: 'Sektorer', value: 'Fødevareindustri, lager, pharma & fremstilling' },
      { label: 'Drift', value: 'Kontinuerlig overvågning & redundans' }
    ]
  },
  {
    id: 'comfortkoel',
    slug: 'comfortkoel',
    title: 'Comfortkøl',
    shortTitle: 'Comfortkøl',
    tagline: 'Optimalt indeklima og præcis temperaturregulering i erhvervsbygninger og kontorer',
    metaTitle: 'Comfortkøl & Klimaanlæg til Kontor & Erhverv | Morine Klimateknik',
    metaDescription: 'Støjsvage og diskrete klimaanlæg, ventilationskøling og serverrumskøling til erhvervsdomiciler og kontorer på Sjælland. Få et sundt indeklima.',
    gallerySlug: 'comfortkol',
    icon: 'fa-solid fa-wind',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/comfortkoel-kontor.jpg',
    description: 'Et godt indeklima er afgørende for produktivitet og trivsel. Vi installerer diskrete og effektive comfortkøleanlæg, ventilationskøling og klimaanlæg til kontordomiciler, mødelokaler, serverrum og erhvervslejemål.',
    points: [
      'Støjsvage og diskrete lofts- og vægmonterede klimaanlæg',
      'Køling og affugtning for optimalt indeklimakomfort',
      'Præcisionskøling til serverrum og IT-infrastruktur',
      'Zoneopdelt styring for individuel temperaturkontrol',
      'Energieffektiv drift tilpasset bygningens brugsmønster'
    ],
    environmentalPoints: [
      'Behageligt og produktivt arbejdsmiljø',
      'Lavt lydniveau og diskret integration',
      'Effektiv styring minimerer unødigt energiforbrug',
      'Forbedret luftkvalitet og temperaturbalance'
    ],
    technicalHighlights: [
      { label: 'Miljøer', value: 'Kontorer, møderum, serverrum & klinikker' },
      { label: 'Egenskaber', value: 'Lydløs drift, zonekontrol & filtrering' },
      { label: 'Integration', value: 'Arkitektonisk diskret indbygning' }
    ]
  },
  {
    id: 'koelemarked-convenience',
    slug: 'koelemarked-convenience',
    title: 'Kølemarked & conveniencekøl',
    shortTitle: 'Kølemarked & convenience',
    tagline: 'Fleksible og driftssikre kølediske og displayenheder til hurtighandel og convenience',
    metaTitle: 'Kølemarked & Conveniencekøl | Salgsfremmende Møbler & Moduler',
    metaDescription: 'Kompakte plug-in kølemøbler, displaykølere og modulære kølerum til conveniencebutikker, tankstationer og kiosker. Høj salgseffekt og lavt energiforbrug.',
    gallerySlug: 'conveniencekol',
    icon: 'fa-solid fa-cart-shopping',
    heroImage: 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/conveniencekoel-butik.jpg',
    description: 'Convenience-butikker, kiosker og tankstationer har brug for kompakte, robuste og driftssikre kølemøbler med stor salgseffekt. Vi rådgiver og leverer displaykølere, plug-in møbler og modulære kølerum skræddersyet til mindre arealer.',
    points: [
      'Plug-in og centralt koblede køle- og frostdistributionsmøbler',
      'Grab-and-go moduler med god synlighed for kunden',
      'Driftssikre komponenter designet til høj kundetrafik',
      'Kompakt design med maksimal udnyttelse af butiksarealet',
      'Hurtig installation og pålidelig servicering'
    ],
    environmentalPoints: [
      'Garanteret stabil produkttemperatur',
      'Moderne energibesparende kompressorer',
      'Kompakt design med høj kapacitet',
      'Driftsikkerhed ved hyppig døråbning'
    ],
    technicalHighlights: [
      { label: 'Segment', value: 'Tankstationer, kiosker, caféer & convenience' },
      { label: 'Formater', value: 'Grab-and-go, displaykøl & modulære kølerum' },
      { label: 'Fordele', value: 'Hurtig montage & lavt energiforbrug' }
    ]
  }
];

export const NAV_LINKS = [
  { label: 'Forside', path: '/' },
  {
    label: 'Ydelser',
    path: '/ydelser',
    children: [
      { label: 'Energioptimering', path: '/ydelser/energioptimering', icon: 'fa-solid fa-bolt' },
      { label: 'Varmepumper', path: '/ydelser/varmepumper', icon: 'fa-solid fa-temperature-arrow-up' },
      { label: 'Grøn udvikling', path: '/ydelser/groen-udvikling', icon: 'fa-solid fa-leaf' },
      { label: 'Butikskøl', path: '/ydelser/butikskoel', icon: 'fa-solid fa-store' },
      { label: 'Industrikøl', path: '/ydelser/industrikoel', icon: 'fa-solid fa-industry' },
      { label: 'Comfortkøl', path: '/ydelser/comfortkoel', icon: 'fa-solid fa-wind' },
      { label: 'Kølemarked & conveniencekøl', path: '/ydelser/koelemarked-convenience', icon: 'fa-solid fa-cart-shopping' }
    ]
  },
  { label: 'Om os', path: '/om-os' },
  { label: 'Kontakt', path: '/kontakt' }
];

export const SEO_CONFIG = {
  home: {
    title: 'Morine Køl & Klimateknik | Professionel Køleteknik & Varmepumper i Hillerød',
    description: 'Autoriseret rådgivning, installation og service af køleanlæg, varmepumper, butikskøl og industrikøl i Hillerød, Nordsjælland og Storkøbenhavn. Ring 50 90 00 67.'
  },
  services: {
    title: 'Ydelser & Klimaløsninger | Morine Køl & Klimateknik',
    description: 'Komplette løsninger inden for energioptimering, varmepumper, butikskøl, industrikøl, comfortkøl og grøn udvikling til erhverv og industri på Sjælland.'
  },
  about: {
    title: 'Om Os | Morine Køl & Klimateknik i Hillerød',
    description: 'Lær mere om Morine Køl & Klimateknik. Vi leverer høj faglig ekspertise, driftssikre anlæg og autoriseret køleservice til virksomheder på Sjælland.'
  },
  contact: {
    title: 'Kontakt Os | Morine Køl & Klimateknik – Tlf. 50 90 00 67',
    description: 'Kontakt Morine Køl & Klimateknik på Frydenborgvej 27, 3400 Hillerød. Ring på 50 90 00 67 eller send en besked for uforpligtende rådgivning og tilbud.'
  },
  notFound: {
    title: '404 - Siden Blev Ikke Fundet | Morine Køl & Klimateknik',
    description: 'Siden du leder efter findes desværre ikke. Gå til forsiden eller udforsk vores ydelser inden for køleteknik og varmepumper.'
  },
  forbidden: {
    title: '403 - Adgang Nægtet | Morine Køl & Klimateknik',
    description: 'Du har ikke tilladelse til at tilgå denne ressource. Vend tilbage til forsiden af Morine Køl & Klimateknik.'
  }
};
